import * as React from 'react';

interface IPdfErrorBoundaryProps {
  children: React.ReactNode;
  onError?: (error: Error) => void;
}

interface IPdfErrorBoundaryState {
  hasError: boolean;
  message: string;
}

export class PdfErrorBoundary extends React.Component<
  IPdfErrorBoundaryProps,
  IPdfErrorBoundaryState
> {
  public constructor(props: IPdfErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error: Error): IPdfErrorBoundaryState {
    const message =
      error && error.message ? error.message : 'Unable to display the PDF.';
    return { hasError: true, message };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[PdfErrorBoundary] caught rendering error from pdf.js', {
      error,
      componentStack: errorInfo && errorInfo.componentStack,
    });
    if (this.props.onError) {
      this.props.onError(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className='pdf-viewer-unavailable text-center text-muted'
          style={{ padding: '1rem' }}
          title={this.state.message}
        >
          <i className='fas fa-file-excel fa-2x' aria-hidden='true'></i>
          <div style={{ marginTop: '0.5rem', fontSize: '0.85rem' }}>
            Thumbnail not available
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
